import { render, staticRenderFns } from "./VCardHeader.vue?vue&type=template&id=717f32eb&scoped=true&"
import script from "./VCardHeader.vue?vue&type=script&lang=js&"
export * from "./VCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./VCardHeader.vue?vue&type=style&index=0&id=717f32eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f32eb",
  null
  
)

export default component.exports